import { Box, Flex, VStack } from "@chakra-ui/react";

import Footer from "../components/Footer";
import TopLogo from "../components/TopLogo";

export default function BaseLayout({ isHome, network, children }) {
    return (
        <Flex flexDir="column" minH="100vh">
            <TopLogo network={network} />

            <Box flex="1" bg="white" px="10" fontSize="sm" py="5">
                <VStack spacing={4} align="stretch">
                    {children}
                </VStack>
            </Box>
            <Footer isHome={isHome} />
        </Flex>
    );
}
